import React from "react";
import {
  StyledChatSidebar,
  StyledChatSidebarSearch,
  StyledChatSidebarSearchView,
} from "./index.styled";
import UserTabs from "./UserTabs";
import { useIntl } from "react-intl";
import { useSidebar } from "@lib/context/SidebarContext";

const ChatSideBar: React.FC = () => {
  const { messages } = useIntl();
  const { collapsed } = useSidebar();
  // const { collapsed } = useSidebar();
  // const navigator = useNavigate();
  // const [msgId, setMsgId] = useState("");

  return (
    <StyledChatSidebar collapsed={collapsed}>
      {/* <StyledChatSidebarHeader>
        <StyledChatSidebarUserView>
          <RiArrowLeftLine
            style={{ cursor: "pointer" }}
            onClick={() => {
              // msgId ? navigator("/alerts") : navigator("/whatsapp-account");
            }}
          />
        </StyledChatSidebarUserView>
      </StyledChatSidebarHeader> */}
      <StyledChatSidebarSearchView style={{ display: "none" }}>
        <StyledChatSidebarSearch
          placeholder={messages["common.searchHere"] as string}
        />
      </StyledChatSidebarSearchView>
      <UserTabs chatListData={[]} isLoading={false} />
    </StyledChatSidebar>
  );
};

export default ChatSideBar;
